import {
	DateRange,
	ProcessStatus,
	ProcessStatusByProcessIdResponse,
	Profiles,
	SortInterface,
	TransactionResponse,
} from '../interfaces/ImportHistory';
import { EMPTY_STRING, INITIAL_PAGE_STATE } from '../shared/constants/constants';
import { formatShortDate, getSortByColumnName } from '../shared/helpers/importHistoryHelper';
import { CalculationType } from './../interfaces/Mapping';
import { INITIAL_DATE_RANGE } from './../shared/constants/ImportHistoryConstants';
import { EMPTY_ARRAY, INITIAL_SORT_COLUMN_DESC } from './../shared/constants/constants';
import axios, { AxiosResponse } from 'axios';

const BATCH_IMPORT_URL = '/api/v1/batch/processes';
const BATCH_GET_STATUS = '/api/v1/batch/processes/status';
const BATCH_GET_PROFILES = '/api/v1/batch/profiles?scope=global';
const BATCH_GET_CALC_TYPES = '/api/v1/batch/calc-types';
const BATCH_EXPORT_URL = '/api/v1/batch/export';

export const ImportHistoryApi = {
	async getImportHistory(
		currentPage: number = INITIAL_PAGE_STATE.page,
		itemsPerPage: number = INITIAL_PAGE_STATE.perPage,
		sortedColumn: SortInterface = INITIAL_SORT_COLUMN_DESC,
		dateRange: DateRange = INITIAL_DATE_RANGE,
		searchText: string = EMPTY_STRING,
		status: string[] = EMPTY_ARRAY,
		profiles: string[] = EMPTY_ARRAY,
		startDates: string[] = EMPTY_ARRAY
	): Promise<TransactionResponse> {
		return axios({
			method: 'GET',
			url: BATCH_IMPORT_URL,
			params: {
				page: currentPage - 1,
				perPage: itemsPerPage,
				period: `${formatShortDate(dateRange.start)},${formatShortDate(dateRange.end)}`,
				sortBy: getSortByColumnName(sortedColumn.id),
				order: sortedColumn.isAscending ? 'ASC' : 'DESC',
				search: searchText,
				processStatuses: status.join(),
				sources: profiles.join(),
				dates: startDates.join(),
			},
		})
			.then(response => {
				if (response.status === 200) {
					return response.data.data;
				}
			})
			.catch(error => {
				console.error('error', error);
			});
	},

	async getProcessStatus(): Promise<ProcessStatus[]> {
		return axios({
			method: 'GET',
			url: BATCH_GET_STATUS,
		})
			.then(response => {
				if (response.status === 200) {
					return response.data.data;
				}
			})
			.catch(error => {
				console.error(error);
			});
	},

	async getProcessStatusByProcessId(processId: string): Promise<ProcessStatusByProcessIdResponse> {
		return axios({
			method: 'GET',
			url: `${BATCH_IMPORT_URL}/${processId}/status`,
		})
			.then(response => {
				return response.data;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},

	async getSummaryByProcessId(processId: string, page: number = 0, perPage: number = 20): Promise<AxiosResponse> {
		return axios({
			method: 'GET',
			url: `${BATCH_IMPORT_URL}/${processId}/summary?page=${page}&perPage=${perPage}`,
		})
			.then(response => {
				return response.data;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},

	async getReportByProcessId(reportType: string, processId: string): Promise<AxiosResponse> {
		return axios({
			method: 'GET',
			url: `${BATCH_EXPORT_URL}/${reportType}/${processId}${reportType === 'error' ? '?type=calculation' : ''} `,
			headers: {
				Accept: 'application/zip, application/json',
			},
			responseType: 'blob',
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},

	async getProfiles(): Promise<Profiles[]> {
		return axios({ method: 'GET', url: BATCH_GET_PROFILES })
			.then(response => {
				if (response.status === 200) {
					return response.data.data.content;
				}
			})
			.catch(error => {
				console.error(error);
			});
	},
	async getCalcTypes(): Promise<CalculationType[]> {
		return axios({
			method: 'GET',
			url: BATCH_GET_CALC_TYPES,
		})
			.then(response => response.data.data)
			.catch(error => console.log('Error: ', error));
	},

	async getProcess(processId: string): Promise<AxiosResponse> {
		return axios({
			method: 'GET',
			url: `${BATCH_EXPORT_URL}/${processId}`,
			headers: {
				Accept: 'application/zip, application/json',
			},
			responseType: 'blob',
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},

	async getProcessSummaryByProcessId(processId: string): Promise<AxiosResponse> {
		return axios({
			method: 'GET',
			url: `${BATCH_EXPORT_URL}/summary/${processId}`,
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},

	async removeProcess(processId: string): Promise<AxiosResponse> {
		return axios({
			method: 'DELETE',
			url: `${BATCH_IMPORT_URL}/${processId}`,
		})
			.then(response => {
				return response;
			})
			.catch(error => {
				console.error(error);
				throw error;
			});
	},
};
